// 1С Fitness service ID for personal training appointments.
// Source: 1С backend, fixed per service catalog. Change only if the
// service is replaced in 1С (rare).
export const PERSONAL_TRAINING_SERVICE_ID = "78b233ea-12b8-11ef-8baf-2a618cb265e1";
